import React from 'react'
import Swatch from './Swatch'

interface SwatchContainerProps {
  values: any[]
  checkboxStates: { [key: string]: boolean }
  onFilterChange: (filter: string, paramName: string) => void
  swatchAppearance: string
  paramName: string
}

const SwatchContainer: React.FC<SwatchContainerProps> = ({
  values,
  checkboxStates,
  onFilterChange,
  swatchAppearance,
  paramName,
}) => {
  const containerClasses =
    swatchAppearance === 'swatch-checkbox'
      ? 'flex flex-col gap-2 mt-7'
      : 'flex flex-row flex-wrap gap-2 mt-7'

  return (
    <div className={containerClasses}>
      {values.map((value, index) => {
        const inputId = `Filter-${paramName.trim()}-${index}`
        return (
          <Swatch
            key={inputId}
            value={value}
            isSelected={checkboxStates[value.label] || false}
            onClick={() => onFilterChange(value.label, paramName)}
            swatchAppearance={swatchAppearance}
          />
        )
      })}
    </div>
  )
}

export default SwatchContainer
